import { API } from '@thuas/pd-schemas';
import api from 'helpers/api';
import { prepareForBackend } from 'helpers/objects';

export type IMenuItem = API['MenuItem']['read'];
export type IMenuItemCreate = API['MenuItem']['create'];
export type IMenuItemUpdate = API['MenuItem']['update'] & {
  itemsOverwrite?: { id: number }[];
};

function prepareForUpdate(menuItem: IMenuItem): IMenuItemUpdate {
  const updated = prepareForBackend(menuItem, ['id']) as IMenuItemUpdate;
  return updated;
}
function prepareForCreate(menuItem: IMenuItem): IMenuItemCreate {
  return prepareForBackend(menuItem, ['id']) as IMenuItemCreate;
}

export const postMenuItem = async (data: IMenuItem) => {
  try {
    const response: any = await api.post('MenuItem', prepareForCreate(data));
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const patchMenuItem = async (data: IMenuItem) => {
  try {
    const response = await api.patch(
      'MenuItem/' + data.id,
      prepareForUpdate(data),
    );
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};

export const deleteMenuItem = async (id: number) => {
  try {
    const response: any = await api.delete('MenuItem/' + id);
    return response;
  } catch (error: any | { response?: any }) {
    throw error?.response || error;
  }
};
